export default "__VITE_ASSET__BmP0sth___"